<template>
  <BaseModal
    :heading="$t('customers.new_loyalty_points')"
    small
    @close="$emit('close')"
    useForm
    @submit="submit"
  >
    <Flex direction="column">
      <BaseInput
        v-model="description"
        :label="$t('global.description')"
        required
        focus
        v-test="'addLPDescription'"
      />
      <BaseInput
        v-model="amount"
        :label="$t('global.amount')"
        required
        type="number"
        controls
        v-test="'addLPAmount'"
      />
      <BaseAlert
        color="warning"
        :text="$t('customers.new_loyalty_points_points')"
      />
    </Flex>
    <template #footer>
      <BaseButton
        submitForm
        v-test="'addLPSave'"
      >
        {{ $t('global.actions.save') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import dayjs from '@/dayjs';

export default defineComponent({
  emits: ['submit', 'close'],
  data() {
    return {
      customer_id: null,
      description: '',
      amount: 0,
    };
  },
  watch: {
    '$route.params.customerId': {
      handler() {
        this.customer_id = Number.parseInt(this.$route.params.customerId);
      },
      immediate: true,
    },
  },
  methods: {
    submit() {
      const obj = {
        description: this.description,
        amount: this.amount,
        transaction_at: dayjs().format(),
        customer_id: this.customer_id,
      };

      this.$emit('submit', obj);
      this.$emit('close');
    },
  },
});
</script>
